import { input } from '@b2b/types/core';
import { WillCallOrderItemsByEventVo } from '@b2b/types/order/api/will-call-order-detail.type';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

interface OrderServiceType {
  getItemType: (type: string, subType?: string) => string;
}

class ExistingOrderGiftCardsController {
  static $inject = ['$element', 'OrderService'];

  event = input<WillCallOrderItemsByEventVo>()!;

  constructor(
    private $element: JQuery,
    private orderService: OrderServiceType,
  ) {}

  $onInit() {
    this.$element.addClass('acme-existing-order-gift-cards');
  }

  getItemType(itemType: string): string {
    return this.orderService.getItemType(itemType);
  }
}

export const ExistingOrderGiftCardsComponentModule = angular
  .module('acme.view.application.orders.edit.components.existing-order-gift-cards', [
    uiRouter,
    'acme.common.service.order',
  ])
  .component('acmeExistingOrderGiftCards', {
    templateUrl: `views/application/views/orders/edit/components/existing-order-gift-cards/existing-order-gift-cards.component.tpl.html`,
    controller: ExistingOrderGiftCardsController,
    controllerAs: '$ctrl',
    bindings: {
      event: '<',
    },
  }).name;

export { ExistingOrderGiftCardsController };
